export const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_API_URL = API_URL + '/api/auth/local'
export const FORGOT_PASSWORD = API_URL + '/api/auth/forgot-password'
export const RESET_PASSWORD = API_URL + '/api/auth/reset-password'
export const REGISTER_USER = API_URL + '/api/auth/local/register'
export const USERS_AUTH_API_URL = API_URL + '/api/users'
export const USER_AUTH_ME_API_URL = API_URL + '/api/users/me'
export const SHOPPERS_API_URL = API_URL + '/api/shoppers/findAvailableShoppers'
export const PRODUCTS_BY_SHOPPER_API_URL = API_URL + '/api/products-shopper'
export const PAGINAS_SHOPPER_API_URL = API_URL + '/api/paginas-shopper'
export const PAGINA_SHOPPER_API_URL = API_URL + '/api/paginas-shopper/:paginaId'
export const LISTAS_API_URL = API_URL + '/api/listas'
export const LISTA_API_URL = API_URL + '/api/listas/:listaId'
export const EMAILS_API_URL = API_URL + '/api/emails'

export const SUSCRIBERS_CREATE = 'https://api.createsend.com/api/v3.3/subscribers/:listaId.json'
export const FOOTER_API_URL = API_URL + '/api/footer'
export const REDES_SOCIALES_API_URL = API_URL + '/api/red-social'
export const NAVBAR_LINKS_API_URL = API_URL + '/api/links-navbars'
